import PropTypes from 'prop-types';

import { Section, SectionAlternate } from '@/src/components/organisms';

export default function SectionDynamic(props) {
  const { className, type, children, ...rest } = props;

  switch (type) {
    case 'none':
      return children;
    case 'alternate':
      return (
        <SectionAlternate className={className} {...rest}>
          {children}
        </SectionAlternate>
      );
    default:
      return (
        <Section className={className} {...rest}>
          {children}
        </Section>
      );
  }
}

SectionDynamic.propTypes = {
  className: PropTypes.string,
  type: PropTypes.string,
  children: PropTypes.node,
};
